import axiosConfig from "config/axiosConfig";
import CardCategoryArticle from "components/Frontend/Card/CardCategoryArticle";
import CardContentHome from "components/Frontend/Card/CardContentHome";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import parse from "html-react-parser";
import UrlImage from "config/UrlImage";

function DetailProject(props) {
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [project, setProject] = useState([]);

  useEffect(() => {
    let isMounted = true;
    const project_slug = props.match.params.slug;
    axiosConfig.get(`/api/project/detail/${project_slug}`).then((res) => {
      if (isMounted) {
        if (res.data.status === 200) {
          setProject(res.data.project);
          setLoading(false);
        } else if (res.data.status === 404) {
          history.push("/project");
          Swal.fire("Warnig", res.data.message, "warning");
        }
      }
    });
    return () => {
      isMounted = false;
    };
  }, [props.match.params.slug, history]);

  if (loading) {
    return (
      <div className="text-center">
        <div className="spinner-grow text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="details-header">
      <div className="py-3">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-title">
                  <h3 className="container mt-4">{project.name}</h3>
                  <h5 className="container">Pengenalan Laravel</h5>
                </div>
                <div className="card-body">
                  <p>
                    <img
                      src={`${UrlImage}/${project.image}`}
                      alt="project image"
                      className="w-100"
                    />
                  </p>
                  <p>{parse(project.description)}</p>
                </div>
              </div>
            </div>

            {/* <div className="col-md-4 border-end">
              
            </div> */}

            <div className="mt-2">
              <hr />
            </div>
            <CardContentHome />
          </div>
        </div>
      </div>
    </div>
  );
}

export default DetailProject;
